import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable()
export class ProfileService {

  constructor(private http: HttpClient) {
  }

  updateProfile(postForm: Object): Observable<any> {
    return this.http
      .put(environment.baseUrlWs + environment.wsVerison + 'employer/profile/', postForm);
  }

  activateTaleo(postForm: Object): Observable<any> {
    return this.http
      .put(environment.baseUrlWs + environment.wsVerison + 'employer/profile/', postForm);
  }

  getUser() {
    return this.http.get(environment.baseUrlWs + environment.wsVerison + 'employer/user/');
  }

  getEmployer(id: number) {
    return this.http.get(environment.baseUrlWs + environment.wsVerison + 'employer/user/get-employer/' + id);
  }

  getProfile() {
    return this.http.get(environment.baseUrlWs + environment.wsVerison + 'employer/profile/');
  }

  createProfile(profileForm: Object) {
    return this.http.post(environment.baseUrlWs + environment.wsVerison + 'employer/profile/', profileForm);
  }

  deleteProfile() {
    return this.http.delete(environment.baseUrlWs + environment.wsVerison + 'employer/profile/')
  }

  updateEmployerImg(image: string) {
    return this.http.put(environment.baseUrlWs + environment.wsVerison + 'employer/profile/img/', {img: image});
  }

  updateEmployerCoverVideo(formData) {
    return this.http.post(environment.baseUrlWs + environment.wsVerison + 'employer/profile/upload-cover-video', formData, {})
  }

  deleteEmployerCoverVideo() {
    return this.http.delete(environment.baseUrlWs + environment.wsVerison + 'employer/profile/delete-cover-video', {})
  }

  updateEmployerCoverImg(formData) {
    return this.http.post(environment.baseUrlWs + environment.wsVerison + 'employer/profile/upload-cover-img', formData, {})
  }

  deleteEmployerCoverImg() {
    return this.http.delete(environment.baseUrlWs + environment.wsVerison + 'employer/profile/delete-cover-img', {})
  }

  // Moments
  createMoment(image: string, profileId: number) {
    return this.http
      .post(environment.baseUrlWs + environment.wsVerison + 'employer/profile/moments/', {
        img: image,
        profiles_id: profileId
      });
  }

  deleteMoment(id: number) {
    return this.http
      .delete(environment.baseUrlWs + environment.wsVerison + 'employer/profile/moments/' + id);
  }


  resetPassword(oldPassword: string, newPassword: string, newPasswordRepeat: string) {
    return this.http
      .post(environment.baseUrlWs + 'v2/reset/change/', {
        old_password: oldPassword,
        new_password_one: newPassword,
        new_password_two: newPasswordRepeat
      });
  }


}
